import styles from "../../styles/PLMApp.module.css";
// src/components/plm/AnimatedDonut.jsx

import { useSpring, animated, config } from "@react-spring/web";

export default function AnimatedDonut({ pct }) {
  const size = 110;
  const stroke = 10;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const cx = size / 2;
  const cy = size / 2;

  const spring = useSpring({
    from: { val: 0 },
    to: { val: pct },
    delay: 300,
    config: config.molasses,
  });

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={styles.sideProgressDonut}
    >
      {/* Track */}
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke="rgba(200,169,110,0.10)"
        strokeWidth={stroke}
      />
      {/* Animated fill */}
      <animated.circle
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke="url(#donutGrad)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={circ}
        strokeDashoffset={spring.val.to((v) => circ - (v / 100) * circ)}
        transform={`rotate(-90 ${cx} ${cy})`}
      />
      <defs>
        <linearGradient id="donutGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#c8a96e" />
          <stop offset="100%" stopColor="#dfc07e" />
        </linearGradient>
      </defs>
      {/* Centre label */}
      <text
        x={cx}
        y={cy - 4}
        textAnchor="middle"
        fill="#f0e8d0"
        fontFamily="'Cormorant Garamond', serif"
        fontSize="22"
        fontWeight="300"
      >
        {pct}
      </text>
      <text
        x={cx}
        y={cy + 13}
        textAnchor="middle"
        fill="#7a8078"
        fontFamily="'Montserrat', sans-serif"
        fontSize="8"
        fontWeight="600"
        letterSpacing="1"
      >
        % DONE
      </text>
    </svg>
  );
}
